export const SET_TRANS_HISTORY = "SET_TRANS_HISTORY";
export const SET_TRANS_HISTORY_RESET = "SET_TRANS_HISTORY_RESET";

// Lấy danh sách sao kê
export const FETCH_TRANS_HISTORY_REQUEST = "FETCH_TRANS_HISTORY_REQUEST";
export const FETCH_TRANS_HISTORY_SUCCESS = "FETCH_TRANS_HISTORY_SUCCESS";
export const FETCH_TRANS_HISTORY_FAILURE = "FETCH_TRANS_HISTORY_FAILURE";

// Lấy sổ phụ sao kê
export const FETCH_TRANS_HISTORY_BACKUP_REQUEST = "FETCH_TRANS_HISTORY_BACKUP_REQUEST";
export const FETCH_TRANS_HISTORY_BACKUP_SUCCESS = "FETCH_TRANS_HISTORY_BACKUP_SUCCESS";
export const FETCH_TRANS_HISTORY_BACKUP_FAILURE = "FETCH_TRANS_HISTORY_BACKUP_FAILURE";
